import { Component, Injector, ViewChild, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseOption, JkJobKind, close2AllList, idNameItem, jkLib, login } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { JkdaterangeComponent, JkComboboxComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkmultiselectComponent, JkReportComponent, JkbtneditComponent } from 'jk-advcom';

export class PageOption extends JkBaseOption { // ###
  date1: string = '';
  date2: string = '';
  uid: string;
  userList: any[] = [];
  finalCode: string = ''; //
  finalCodeList: idNameItem[] = close2AllList;
  customers: idNameItem[] = jkLib.stringList2IdNameItem(['AJM']);
  customerList: any[] = [];

  constructor(name: string) {// ###
    super(name);
    this.uid = login.userid;
    this.date1 = jkLib.nowDate();
    this.date2 = jkLib.nowDate();

    this.userList.push({ id: this.uid, name: this.uid });
  }
  override init() {
    super.init();
    this.orm.getopenwin('CMSMV', 'W01', 'W')
      .subscribe((data) => {
        this.userList = data;
      });
    this.orm.getopenwin('COPMA', 'W01', 'W')
      .subscribe((data) => {
        this.customerList = data;
      });
  }

}


@Component({
  selector: 'app-mtrkr03',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, JkbtneditComponent, JkmultiselectComponent],
  templateUrl: './mtrkr03.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mtrkr03.component.scss'
})
export class Mtrkr03Component extends JkReportComponent {
  override _programId = 'mtrkr03';
  @ViewChild('mtrwd002') mtrwd002!: JkdaterangeComponent;
  @ViewChild('mtrwd017') mtrwd017!: JkComboboxComponent;
  @ViewChild('mtrwd021') mtrwd021!: JkmultiselectComponent;
  pageOpt: PageOption = new PageOption(this.programId);//###
  //masterSrv!: SyskaService<Syska>; // ar myTable: pkgTableClass = new pkgTableClass("data", "SYSKA", "", "KA001,KA002,KA003,KA004", "", jkGlb.User.serverUrl, "");

  constructor() {
    super();
    this.setFormOpt2();
    this.reportType = '1';
    this.reportTypeList = [{ id: '1', name: '(1)日期別' }, { id: '1', name: '(1)客戶別' }, { id: '3', name: '(3)工作人員別' }];
  }
  async doReport() {
    this.job.options = [];
    //xName xCaption xKind xData xType xPs
    this.job.addOption("cboReportType", "報表格式", "TjkComboBox", this.reportType, "", "");
    this.job.addOption("rgWD002", "工作日期", "TJKRange", this.pageOpt.date1 + "～" + this.pageOpt.date2, "", "");
    this.job.addOption("msWD014", "員工代號", "TjkMultiSelect", this.pageOpt.uid, "", "");
    let cList = this.pageOpt.customers.map((item) => item.id);
    this.job.addOption("msWD021", "客戶代號", "TjkMultiSelect", cList.join(","), "", "");
    this.job.addOption("cboWD017", "結案狀態", "TjkComboBox", this.pageOpt.finalCode, "", "");
    this.ret = await this.job.jobInsert("3", this.programId, JkJobKind.Report); //空白 或 3    空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知
    if (this.ret.result) {
      this.navigateTo('/reportview');
    }
    //myRefresh(null);

  }

}
/*
let opt: JkJobOption;

opt = new JkJobOption();// 一定要重覆宣告.不然會全部ARRAY一樣
opt.caption = "報表格式";
opt.data = this.reportType;
opt.kind = "TjkComboBox";
opt.name = "cboReportType";
this.job.options.push(opt);


opt = new JkJobOption();
opt.caption = "工作日期";
opt.data = this.pageOpt.date1 + "～" + this.pageOpt.date2;
opt.kind = "TJKRange";
opt.name = "rgWD002";
opt.ps = "";
opt.type = "";
this.job.options.push(opt);

opt = new JkJobOption();// 一定要重覆宣告.不然會全部ARRAY一樣
opt.caption = "員工代號";
opt.data = this.pageOpt.uid; // jkGlb.User.userid;
opt.kind = "TjkMultiSelect";
opt.name = "msWD014";
this.job.options.push(opt);

opt = new JkJobOption();// 一定要重覆宣告.不然會全部ARRAY一樣
opt.caption = "客戶代號";
opt.data = this.pageOpt.customers.join(",");
opt.kind = "TjkMultiSelect";
opt.name = "msWD021";
this.job.options.push(opt);

opt = new JkJobOption();// 一定要重覆宣告.不然會全部ARRAY一樣
opt.caption = "結案狀態";
opt.data = this.pageOpt.finalCode;
opt.kind = "TjkComboBox";
opt.name = "cboWD017";
this.job.options.push(opt);
*/
